import React from "react";

import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router";

import { lastSmokedSchema } from "./formValidation";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { RadioButtonGroup } from "../../../atoms/react-hook-form/RadioButtonGroup/RadioButtonGroup";
import {
  ModalPageBody,
  ModalPageWrapper,
  ModalPageCopy,
  ModalPageHeading,
  ModalPageHeader,
  ModalPageFooter,
} from "../../../organisms/ModalPage";
import { smokeFreePageTitleSuffix } from "../../../../data/eligibilityChecker";

interface LastSmokedProps {}

export const LastSmoked: React.FC<LastSmokedProps> = (props: LastSmokedProps) => {
  const { handleSubmit, control } = useForm<any>({
    resolver: yupResolver(lastSmokedSchema),
    defaultValues: { smokedIn48h: "" },
  });
  const history = useHistory();

  const onSubmit = values => {
    if (values.smokedIn48h === "Yes") {
      history.push(`/postcode`);
    } else {
      history.push(`/smoked-in-48h/fail`);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="last-smoked-page form eligibility-checker-form">
      <Helmet>
        <title>{`Last smoked | ${smokeFreePageTitleSuffix}`}</title>
      </Helmet>
      <ModalPageWrapper className="otp-email" alignItems="center">
        <ModalPageBody hasStickyFooter={true}>
          <>
            <ModalPageHeader
              backButtonOnClick={() => {
                history.goBack();
              }}
              backButtonText="Back"
            >
              Checking we're a good fit
            </ModalPageHeader>
            <ModalPageHeading size="large">Have you smoked tobacco in the last 48 hours?</ModalPageHeading>
            <ModalPageCopy>This does not include vapes or heated tobacco.</ModalPageCopy>
          </>

          <div className="form__body">
            <RadioButtonGroup
              name="smokedIn48h"
              control={control}
              options={[
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
              ]}
            />
          </div>

          <Accordion square={true} elevation={0} className="eligibility-checker__accrodion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon fontSize="large" />}
              aria-controls={`disabilities-question-explanation`}
            >
              <span>We know, this stuff is personal! Find out why we need to check.</span>
            </AccordionSummary>
            <AccordionDetails>
              <span>
                For now, we can only support those who smoke tobacco, not tobacco-flavoured vapes or heated
                tobacco.
              </span>
            </AccordionDetails>
          </Accordion>
        </ModalPageBody>
        <ModalPageFooter className="sticky-footer">
          <Button type="submit" variant="contained" color="primary" disabled={false}>
            Continue
          </Button>
        </ModalPageFooter>
      </ModalPageWrapper>
    </form>
  );
};
